import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const enhanceCloseOnOutsideClickHOCGenerator = (Component) => {
  function EnhanceCloseOnOutsideClickHOC(props) {
    const { createdRef, dropdownDisplayed, closeDropdownAndResetMatches } = props;

    useEffect(() => {
      const clickListener = (e) => {
        const { target } = e;
        const domRef = createdRef.current;
        if (domRef && !domRef.contains(target)) {
          closeDropdownAndResetMatches();
        }
      };

      if (dropdownDisplayed) {
        document.addEventListener('click', clickListener);
      }

      return () => {
        document.removeEventListener('click', clickListener);
      };
    }, [dropdownDisplayed]);

    return <Component {...props} />;
  }

  EnhanceCloseOnOutsideClickHOC.propTypes = {
    createdRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
    dropdownDisplayed: PropTypes.bool,
    closeDropdownAndResetMatches: PropTypes.func,
  };

  return EnhanceCloseOnOutsideClickHOC;
};

const enhanceCloseOnOutsideClick = () => (Component) => enhanceCloseOnOutsideClickHOCGenerator(Component);

export default enhanceCloseOnOutsideClick;
